<template>
    <div class="coffee-card-list padded">
        <!-- Carousel -->
        <carousel
            v-if="carousel"
            v-for="(row, i) in Math.ceil(coffees.length / maxCardsPerRow)"
            v-bind="getCarouselOptions()"
            :key="i"
            class="carousel">

            <slide v-for="(coffee, index) in coffees.slice(i * maxCardsPerRow, Math.min((i + 1) * maxCardsPerRow), coffees.length - 1)"
                   v-if="coffee"
                   :key="coffee.id">

                <coffee-card
                    class="coffee-card"
                    :paramfilter="paramfilter"
                    :coffee="coffee"
                    :seller="coffee.seller"
                    :added-to-playlist="playlistItemIds.includes(coffee.id)"
                    :style="{ 'background-color': getBackgroundColor(index, getBackgroundColorOffset(i)) }"
                    :select5lb="select5lb"
                    :default-grind="grindFilter"
                    :brewlist-grind="brewlistDetail || coffee.brewlistDetail"
                    :tax-rate="buyNowProps.taxRate"
                    :measure-unit="buyNowProps.measureUnit"
                    :key="coffee.id"
                    :ref="`coffeeCard${coffee.id}`"
                    v-on:buy-now="buyNow"
                    v-on:add-to-playlist="addCoffeeToPlaylist"
                    v-on:confirm-grind="confirmGrind"
                />

            </slide>
        </carousel>

        <!-- Grid -->
        <div v-if="!carousel" class="grid-layout"> <!-- HACK: v-else creates duplicates coffee cards. Possibly a bug in Vue.js? -->
            <coffee-card
                    v-for="(coffee, index) in coffees"
                    class="coffee-card"
                    :paramfilter="paramfilter"
                    :coffee="coffee"
                    :seller="coffee.seller"
                    :added-to-playlist="playlistItemIds.includes(coffee.id)"
                    :style="{ 'background-color': getBackgroundColor(index, getBackgroundColorOffset(index)) }"
                    :select5lb="select5lb"
                    :tax-rate="buyNowProps.taxRate"
                    :measure-unit="buyNowProps.measureUnit"
                    :default-grind="grindFilter"
                    :brewlist-grind="brewlistDetail || coffee.brewlistDetail"
                    :key="coffee.id"
                    :ref="`coffeeCard${coffee.id}`"
                    v-on:buy-now="buyNow"
                    v-on:add-to-playlist="addCoffeeToPlaylist"
                    v-on:confirm-grind="confirmGrind"
            />
        </div>

        <buy-now-form-shell
                :order="buyNowOrder"
                :buy-now-discounts="buyNowProps.buyNowDiscounts"
                :custom-bag-discounts="buyNowProps.customBagDiscounts"
                :is-user-signed-in="buyNowProps.isUserSignedIn"
                :stripe-publishable-key="buyNowProps.stripePublishableKey"
                :username="buyNowProps.username"
                :email="buyNowProps.email"
                :shipping="buyNowProps.shipping"
                :credit-card-last-digits="buyNowProps.billing && buyNowProps.billing.creditCardLastDigits"
                :applicable-credit-amount-cents="buyNowProps.applicableCreditAmountCents"
                :current-url="buyNowProps.currentUrl"
                :tax-rate="buyNowProps.taxRate"
                :key="componentKeyPrefix + buyNowComponentKey"
                v-on:closed="onBuyNowFormClosed"
                ref="buyNowForm"
        />

        <grind-confirmation-modal
                :grind="grindSelected"
                v-on:confirmed="onGrindConfirmed()"
                ref="grindConfirmationModal"
        />
    </div>
</template>

<script>
    import CoffeeCard from "./coffee-card-home";
    import BuyNowFormShell from "./buy-now/buy-now-form-shell";
    import {Carousel, Slide} from "vue-carousel";
    import CoffeeMixin from "../../mixins/coffee-mixin";
    import BuyNowMixin from "../../mixins/buy-now-mixin";
    import GrindConfirmationModal from './grind-confirmation-modal';

    export default {
        name: 'coffee-card-list',
        components: {
            CoffeeCard,
            Carousel,
            Slide,
            BuyNowFormShell,
            GrindConfirmationModal
        },
        mixins: [
            CoffeeMixin,
            BuyNowMixin
        ],
        props: {
            paramfilter: Object,
            coffees: Array,
            brewlistDetail:Object,
            playlistData: Object,
            maxCardsPerRow: {
                type: Number,
                default: 9
            },
            backgroundColorOffset: {
                type: Number,
                default: 0
            },
            select5lb: {
                type: Boolean,
                default: false
            },
            buyNowProps: Object,
            carousel: {
                type: Boolean,
                default: true
            },
        },
        data: function () {
            return {
                buyNowOrder: undefined,
                buyNowComponentKey: 0,
                componentKeyPrefix: this.getRandomString(),
                coffeeIdSelected: undefined,
                grindSelected: undefined
            }
        },
        methods: {
            addCoffeeToPlaylist(coffeeId, size, grind) {
                this.$emit('add-coffee-to-playlist', coffeeId, size, grind);
            },
            getBackgroundColorOffset(row) {
                const factor = 5;
                return (this.backgroundColorOffset * factor) + (row * factor);
            },
            buyNow(order) {
                this.buyNowOrder = order;
                fbq('track', 'InitiateCheckout');
                // HACK: wait for binding the order
                setTimeout(() => this.$refs.buyNowForm.open(), 250);
            },
            onBuyNowFormClosed() {
                // Vue component will reset data once the key changed.
                this.buyNowComponentKey += 1;
            },
            // HACK: This is a very hacky way to assign unique keys.
            getRandomString() {
                let str = '';

                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for( let i = 0; i < 10; i++ ) {
                    str += chars.charAt(Math.floor(Math.random() * chars.length));
                }
                return str;
            },
            getCarouselOptions() {
                let options = this.carouselOptions();
                // if (this.coffees.length > 10) {
                //     options.paginationEnabled = false;
                // }
                return options;
            },
            confirmGrind(coffeeId, grind, brewGrind) {
                this.coffeeIdSelected = coffeeId;
                this.grindSelected = grind;
                this.$refs.grindConfirmationModal.show(brewGrind);
            },
            onGrindConfirmed() {
                this.$refs[`coffeeCard${this.coffeeIdSelected}`][0].addToPlaylist();
                this.coffeeIdSelected = null;
            }
        },
        computed: {
            playlistItemIds: function() {
                if (!this.playlistData) {
                    return [];
                }
                return this.playlistData.items.map(item => item.item_id);
            },
            grindFilter: function() {
                if (!this.playlistData || !this.playlistData.suggested_filters)
                    return null;

                const filters = this.playlistData.suggested_filters;

                const grinds = ['whole_bean', 'course', 'medium', 'fine'];

                for (const f of filters) {
                    if (grinds.includes(f))
                        return f;
                }

                return null;
            }
        },
        mounted() {
            const incompleteOrder = this.getIncompleteOrder();
            if (incompleteOrder && this.buyNowProps.isUserSignedIn) {
                this.buyNowOrder = incompleteOrder;
                setTimeout(() => this.$refs.buyNowForm.open(true), 3000);
            }
        }
    }
</script>

<style lang="scss">
    @import "./../../styles/variables_home";

    .carousel:not(:first-child) {
        margin-top: 6rem;
    }
    .VueCarousel-navigation-button {
        color: $green!important;
    }
    .VueCarousel-dot-container {
        margin: 0 !important;
    }
    .VueCarousel-navigation--disabled {
        opacity: 0!important;
    }
    .VueCarousel-navigation-button {
        outline: none!important;
    }
    .VueCarousel-dot:focus {
        outline: none!important;
    }
    .grid-layout {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .coffee-card {
            margin-bottom: 4rem;
            margin-left: 1rem;
            margin-right: 1rem;
        }
    }
    .VueCarousel-navigation-prev, .VueCarousel-navigation-next {
        top: 43% !important;
        font-size: 28px;
    }
</style>
